module.exports = __webpack_public_path__ + "img/ershouxianzhi.558ae197.png";